import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import { Downgraded, useState } from '@hookstate/core';
import { Box, CircularProgress } from '@mui/material';
import { useAuthState } from '../../../stores/authStore';
import { useEventState } from '../../../stores/eventStore';
import RouteConstants from '../../../constants/routeConstants';
import APIURLConstants from '../../../config/config';
import ApiHelper from '../../../utility/ApiHelper';
import Helper from '../../../utility/helper';
import CustomizedSnackbars from '../../../sharedcomponents/snackbar/snackBar';
import StyledTableRow from '../../../sharedcomponents/styledTable/styledTableRow';
import StyledTableCell from '../../../sharedcomponents/styledTable/styledTableCell';
import {
    NO_ACCESS_PERMISSION,
    FULL_PERMISSION,
} from '../../../constants/Constant';
import UnauthorizedUI from '../../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import DataList from './dataList/dataList';
import ConfirmationDialog from '../../../sharedcomponents/confirmationdialog/confirmationDialog';
import LocationDialog from './locationDialog';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};
const AllActivitiy = (props) => {
    const showSearch = true;
    const history = useHistory();
    const authState = useAuthState();
    const eventState = useEventState();
    const loading = useState(true);
    const allData = useState([]);
    const allListData = useState();
    const eventData = useState(null);
    const userID = useState(null);
    const requestPending = useState(null);
    const overallParticipants = useState([]);
    const userInfo = useState({});

    const setAll = useState(false);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const isView = useState(false);

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const locationDiaglog = useState({
        open: false,
        title: '',
        message: '',
    });

    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const [locationDisabled, setLocationDisabled] = React.useState(true);
    const [locationData, setLocationData] = React.useState('');
    const [activityLocationErr, setActivityLocationErr] = React.useState('');
    const [modPermission, setModPermission] = React.useState(null);
    const eventInfo = Helper.getStorage('eventInfo');
    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfos = Helper.getStorage('userInfo');
        userInfo.set(userInfos);
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            userID.set(userInfos.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)) {
                setModPermission(FULL_PERMISSION);
            } else if (userInfo.roles && Helper.isEventAdmin(userInfo)) {
                // const permissions = eventState.permissions
                //     .attach(Downgraded)
                //     .get();
                // if (permissions && permissions.length > 0) {
                //     setModPermission(
                //         Helper.getModuleAccessPermission(permissions, 'HOTEL')
                //     );
                // }
                setModPermission(FULL_PERMISSION);
            }
        }
    }, [eventState]);

    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage) {
                getAdminMediaCircuitList();
            }
        }
    }, [modPermission]);

    const getAdminMediaCircuitList = () => {
        const eventInfo = Helper.getStorage('eventInfo');

        loading.set(true);
        ApiHelper.get(APIURLConstants.GET_MEDIA_CIRCUIT(eventInfo.eventID))
            .then((res) => {
                if (res.data) {
                    let data = res.data;
                    let requestData = [];
                    if (data.length > 0) {
                        data.map((item) => {

                            requestData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'mediaCircuitID',
                                        mediaCircuitID: item.mediaCircuitID,
                                        width: '0.05',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Activity Event',
                                        key: 'activityEvent',
                                        activityEvent: item.name,
                                        width: '0.30',
                                        showLabel: false,
                                        alignLeft: true,
                                        inColumn: true,
                                    },
                                    {
                                        label: 'location',
                                        key: 'activityLocation',
                                        activityLocation: item.location,
                                        width: '0.55',
                                        showLabel: false,
                                        alignLeft: true,
                                        inColumn: true,
                                    },
                                    // {
                                    //     label: 'Activity Static Location',
                                    //     key: 'ActivityStaticLocation',
                                    //     ActivityStaticLocation: eventInfo.location,
                                    //     width: '0.55',
                                    //     showLabel: false,
                                    //     alignLeft: true,
                                    //     inColumn: true,
                                    // },
                                    {
                                        label: 'Action',
                                        key: 'All',
                                        all: 'All',
                                        width: '0.10',
                                        inColumn: true,
                                        alignCenter: false,
                                    },
                                ],
                                selected: false,
                            });
                        });
                    } else {
                        <StyledTableRow>
                            <StyledTableCell colSpan="7" align="center">
                                No data found
                            </StyledTableCell>
                        </StyledTableRow>;
                    }
                    setShowSearchRec(false);
                    allData.set(requestData);
                    allListData.set(requestData);
                    loading.set(false);
                    if (pagingInfo.get().noOfPages == null) {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
    }
    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
    };

    const handleConfirmation = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');

        let deleteActivityIDs = [];
        allData.get().map((user) => {
            if (user.selected === true) {
                deleteActivityIDs.push(user.actualData.mediaCircuitID);
            }
        });
        let obj = {
            eventID: eventInfo.eventID,
            modifiedBy: userInfo.userID,
            ids: deleteActivityIDs
        }

        if (deleteActivityIDs.length > 0) {
            ApiHelper.post(APIURLConstants.DELETE_MEDIA_CIRCUIT, obj)
                .then(result => {
                    if (result.data) {
                        setSnackBarProps({ openSnack: true, variant: 'success', message: 'Activity deleted successfully.' });
                        isView.set(false);
                        getAdminMediaCircuitList();
                    } else {
                        setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                    }
                    deleteConfirmation.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                })
                .catch(err => {
                    console.log(err);

                    setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                    deleteConfirmation.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                });
        }
    }
    // const saveAppNotificationData = (selectedUsers, resourceID) => {
    //     const AppNotificationData = {
    //         userIDs: selectedUsers.toString(),
    //         appNotificationTypeID: 2,
    //         eventID: eventData.get().eventID,
    //         moduleID: 11,
    //         recordRefID: resourceID,
    //         requestStatus: 2,
    //         status: 0,
    //         createdBy: userInfo.attach(Downgraded).get().userID
    //     }
    //     ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, AppNotificationData)
    //         .then(res => {
    //             console.log("res1", res);
    //         })
    //         .catch(err => {
    //             console.log("err", err);
    //         });
    // } 
    const redirectToEdit = (data) => {
        const row = data.actualData;
        const path = generatePath(RouteConstants.EDIT_ALL_ACTIVITIES, {
            eventID: eventData.get().eventID,
            allActivityID: row.mediaCircuitID,
        });
        history.push({
            pathname: path,
            state: { AllActivityState: row },
        });
    };

    const onAddRequest = () => {
        props.history.push({
            pathname: generatePath(RouteConstants.CREATE_ALL_ACTIVITIES, {
                eventID: eventData.get().eventID,
            }),
            state: {},
        });
    };
    const onDelete = () => {
        const selected = allData.get().filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select activities first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to delete all activities?'
                : 'Do you want to delete selected activities?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const showLocationDiaglog = () => {
        setLocationData(eventInfo.location)
        locationDiaglog.set({
            open: true,
            title: '',
            OkButtonText: 'Submit',
        });
    }
    const handleLocationSubmit = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        if (locationData.trim() === "") {
            setActivityLocationErr('please enter location');
            return
        } else {
            let postObj = {
                eventID: eventInfo.eventID,
                location: locationData.trim()
            }
            ApiHelper.post(APIURLConstants.UPDATE_MEDIA_CIRCUIT_LOCATION, postObj)
                .then(result => {
                    if (result.data) {
                        setSnackBarProps({ openSnack: true, variant: 'success', message: 'Location Updated successfully.' });
                        eventInfo['location'] = locationData.trim();
                        Helper.setStorage('eventInfo', eventInfo);
                        setLocationData('');
                        getAdminMediaCircuitList();
                    } else {
                        setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                    }
                    locationDiaglog.set({
                        open: false,
                        title: '',
                        OkButtonText: '',
                    });
                })
                .catch(err => {
                    console.log(err);
                    setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                    locationDiaglog.set({
                        open: false,
                        title: '',
                        OkButtonText: '',
                    });
                });
        }
    }
    const activityLocationChange = (value) => {
        setActivityLocationErr('');
        (value.length > 1) ? setLocationDisabled(false) : setLocationDisabled(true);
        setLocationData(value);
    }

    const onDragEnd = ({ destination, source }) => {
        if (!destination) return;
        reorder(source.index, destination.index);
    };

    const reorder = (startIndex, endIndex) => {
        const newActivityList = [...allData.attach(Downgraded).get()];
        const [removed] = newActivityList.splice(startIndex, 1);
        newActivityList.splice(endIndex, 0, removed);
        let activityData = [];
        newActivityList.forEach((item, index) => {
            const row = item.actualData;
            activityData.push({
                mediaCircuitID: row.mediaCircuitID,
                order: index + 1,
            });
        });


        allData.set(newActivityList);
        updateActivityOrder(activityData);
    };

    const updateActivityOrder = (data) => {
        ApiHelper.post(APIURLConstants.UPDATE_MEDIA_CIRCUIT_ACTIVITY_ORDER, data)
            .then((res) => {
                if (res.data) {
                }
            })
            .catch((error) => {
                console.log('Error while changing order', error);
            });
    };

    return (
        <Box sx={{ width: '100%' }} className="contentBox">
            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <DataList
                    participants={overallParticipants.attach(Downgraded).get()}
                    data={allData.attach(Downgraded).get()}
                    editRow={redirectToEdit}
                    handleClick={onAddRequest}
                    title={''}
                    buttonTitle={'Add'}
                    deleteRows={onDelete}
                    showSearch={showSearch}
                    searchLabel={'Search'}
                    showSearchRec={showSearchRec}
                    setShowSearchRec={setShowSearchRec}
                    hideApproveReject={true}
                    pagingInfo={pagingInfo.attach(Downgraded).get()}
                    handlePageChange={handlePageChange}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    modPermission={modPermission}
                    moduleToShow={"All Activities"}
                    showLocation={true}
                    showLocationDiaglog={showLocationDiaglog}
                    ShowOverallLocation={true}
                    isDraggable={true}
                    onDragEnd={onDragEnd}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {
                <LocationDialog
                    open={locationDiaglog.get().open}
                    message={locationDiaglog.get().message}
                    OkButtonText={locationDiaglog.get().OkButtonText}
                    handleCnfClick={() =>
                        handleLocationSubmit(locationDiaglog)
                    }
                    activityLocation={locationData}
                    activityLocationErr={activityLocationErr}
                    activityLocationChange={activityLocationChange}
                    onCancelClick={() => {
                        locationDiaglog.set({
                            ...locationDiaglog.get(),
                            open: false,
                        });
                    }}
                    disbaledSubmitButton={locationDisabled}
                ></LocationDialog>
            }
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>

    );
};



export default {
    routeProps: {
        path: RouteConstants.ALL_ACTIVITIES,
        component: AllActivitiy,
    },
    name: 'AllActivitiy',
};
